import { render, staticRenderFns } from "./gislist.vue?vue&type=template&id=be2c562c&scoped=true"
import script from "./gislist.vue?vue&type=script&lang=js"
export * from "./gislist.vue?vue&type=script&lang=js"
import style0 from "./gislist.vue?vue&type=style&index=0&id=be2c562c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be2c562c",
  null
  
)

export default component.exports